/* @HEADER
 * @version 1.0.1526 | 2026-09-18
 * @purpose The one decision the host takes before any provider mounts — is this visitor authenticated, read straight from storage — pure over a getter so node:test can run it (ZVX-DEV-6084, campaign 3 cut 8).
 * @sidecar unauthEntryDecisions.mjs.header.md
 * @layer app | @hex domain | @ctx auth
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-6084, ZVX-DEV-2376

/**
 * ZVX-DEV-2376 — «is the visitor authenticated?» for the SaaS landing gate,
 * taken in App()'s synchronous render before any hook: signed in when the
 * JWT access token OR the local identity is on disk. A storage that is
 * absent or throws reads as anonymous.
 *
 * @param {((key: string) => string | null) | null | undefined} getItem
 * @param {{ accessToken: string, localUserIdentity: string }} keys
 * @returns {boolean}
 */
export function visitorAuthenticatedFrom(getItem, keys) {
  if (typeof getItem !== 'function') return false;
  try {
    return getItem(keys.accessToken) !== null || getItem(keys.localUserIdentity) !== null;
  } catch {
    return false;
  }
}
